<template>
  <div class="currentInventory">
    <div class="tableData-con">
      <div class="tableContent-title">产品信息</div>
      <sp-table
        ref="spTable"
        :parentTableData.sync="productData"
        :parentCol.sync="colList"
        :dragDrop=true
        :id-edit="false"
        width="100%"
        :summary-data="summaryData"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column align="center" type="index" label="序号" width="50" class-name="index"></el-table-column>
        <sp-table-column :align="item.titleAlignment" v-for="(item, index) in colList" :key="`col_${index}`"
                         :width="item.width"
                         sortable
                         :prop="colList[index].field"
        >
          <template slot="header">
            <p>{{item.title}}</p>
          </template>
          <template v-slot="{ scope }">
            <div class="span" :style="{textAlign: item.alignment}">
              {{item.id ? item.id : item.uid}}
              {{scope.row[colList[index].field]}}
            </div>
          </template>
        </sp-table-column>
      </sp-table>
    </div>
    <div class="tableData-con">
      <div class="tableContent-title">罐号信息</div>
      <sp-table
        ref="spTable"
        :parentTableData.sync="listData"
        :parentCol.sync="colList2"
        :summary-data="summaryData"
        :dragDrop=true
        :id-edit="false"
        width="100%"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column align="center" type="index" label="序号" width="50" class-name="index"></el-table-column>
        <sp-table-column :align="item.titleAlignment" v-for="(item, index) in colList2" :key="`col_${index}`"
                         :width="item.width"
                         sortable
                         :prop="colList2[index].field"
        >
          <template slot="header">
            <p>{{item.title}}</p>
          </template>
          <template v-slot="{ scope }">
            <div class="span" :style="{textAlign: item.alignment}">
              {{item.id ? item.id : item.uid}}
              {{scope.row[colList2[index].field]}}
            </div>
          </template>
        </sp-table-column>
      </sp-table>
    </div>
  </div>
</template>
<script>
  import {spTable, spTableColumn} from '@/components/sptable';
  import {swiper, swiperSlide,} from 'vue-awesome-swiper';
  import Jar from './component/Jar';
  import tDialog from '@/components/gridDialog';
  import {mapGetters, mapActions} from 'vuex';
  import 'swiper/dist/css/swiper.css';

  export default {
    components: {
      Jar,
      tDialog,
      swiper,
      swiperSlide,
      spTable,
      spTableColumn
    },
    data() {
      return {
        colList: [],
        colList2: [],
        swiperOption: {
          freeMode: true,
          slidesPerView: 'auto',
          slidesOffsetAfter: 0,
          normalizeSlideIndex: false,
          spaceBetween: 15,
          pagination: {
            el: '.swiper-pagination'
          }
        },
        dialogShow: false,
        productData: [],
        listData: [],
        interval: null,
        height: 0,
        summaryData: []
      };
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
        currInventory: 'dictionary/currInventory',
        currInventory2: 'dictionary/currInventory2',
      }),
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    mounted() {
      this.height = window.document.body.clientHeight - 105;
      this.initCol();
    },
    created() {
      this.getTankGoodsDic(1);
      this.getTankGoodsDic(2);
      this.listGoodsAndTankAPI();
      // 开启定时刷新 30s
      if (this.interval) clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.listGoodsAndTankAPI();
      }, 30000)
    },
    beforeRouteLeave(to, form, next) {
      // 定时器清除
      clearInterval(this.interval);
      next();
    },
    methods: {
      ...mapActions({
        currInventoryAction: 'dictionary/currInventoryAction',
        currInventory2Action: 'dictionary/currInventory2Action',
      }),
      getTankGoodsDic(type) {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'getTankGoodsDic',
          params: {
            accountId: this.userInfor.accountId,
            type
          },
        }).then(res => {
          if (res.code == '000' && res.bean[0]) {
            type === 1 ? this.currInventoryAction(res.bean[0].DataDictID) : '';
            type === 2 ? this.currInventory2Action(res.bean[0].DataDictID) : '';
          }
        })
      },
      getSummaries(param) {
        const countList = ['Number', 'OPCNumber'];
        const countObj = {
          Number: {
            unit: '(t)',
          }, OPCNumber: {
            unit: '(t)',
          },
        };
        const {columns, data} = param;
        let sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (countObj[column.property]) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                }
                return prev;
              }, 0);
              sums[index] = sums[index].toFixed(3);
              sums[index] += countObj[column.property].unit;
            }
            else {
              sums[index] = '';
            }
          }
        });
        this.summaryData = [countList, sums];
        return sums;
      },
      // 获取当前库存查询
      listGoodsAndTankAPI() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'listGoodsAndTank',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.productData = []
          this.listData = []

          this.productData = res.bean.goodsList;
          this.listData = res.bean.tankList;
          /* let goodsList = res.bean.goodsList;
           let tankList = res.bean.tankList;
           let infoGoods = {};
           let infoTank = {};
           goodsList.forEach(itme => {
             infoGoods = {
               title: itme.GoodsName,
               num: itme.Number,
             };
             this.productData.push(infoGoods);
           });
           tankList.forEach(itme => {
             infoTank = {
               type: itme.TankID,
               name: itme.GoodsName,
               num: itme.Number,
             };
             this.listData.push(infoTank);
           });*/
        });
      },
      instal() {
        this.dialogShow = true;
      },
      tdialogClose() {
        this.dialogShow = false;
      },
      initCol() {
        this.currInventory.length > 0
        && (this.colList = this.currInventory.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            return info;
          })
        );
      },
      initCol2() {
        this.currInventory2.length > 0
        && (this.colList2 = this.currInventory2.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            return info;
          })
        );
      }
    },
    watch: {
      currInventory() {
        this.initCol();
      },
      currInventory2() {
        this.initCol2();
      },
      colList(val) {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      colList2(val) {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .tableData-con {
    /*height: 300px;*/
    /*margin-bottom: 70px;*/
    min-height: 100px;
  }

  .col-border {
    border: 1px solid #0d84c5;
    border-radius: 5px;
  }

  .billQuery_top {
    margin-top: 10px;
    padding: 10px 22px;
  }

  .billQuery_main {
    margin-top: 20px;
    padding: 0 5px;
    padding-top: 22px;
  }

  .col-list {
    padding: 0 10px;
    padding-bottom: 22px;
    .listBox {
      padding: 25px 0;
      background: #e7f3ffeb;
      border-radius: 10px;
    }
  }

  // 罐体内容
  .tankBody {
    position: relative;
    top: 30px;
    width: 100%;
    font-size: 16px;
    color: #505050;
    line-height: 30px;
    text-align: center;
    font-weight: 400;
    span {
      padding-left: 10px;
      padding-bottom: 2px;
      font-size: 18px;
      vertical-align: bottom;
    }
  }
</style>
<style lang="scss">
  .swiperCover {
    width: 290px;
  }

  .currentInventory {
    width: 100%;
    overflow-y: scroll;
    .el-table__body-wrapper {
      min-height: 100px;
      max-height: 200px;
      height: auto !important;
    }

    // el-card 覆盖
    .elCard-cover {
      float: left;
      width: 290px;
      max-width: 290px;
      border: 0px solid #ebeef5;
      .el-card__header {
        padding: 0;
      }
      .el-card__body {
        padding: 0;
      }
    }
    // card 样式
    .billQuery_card {
      margin-right: 40px;
      margin-bottom: 20px;
      .el-card__header {
        height: 50px;
        line-height: 50px;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
        background: linear-gradient(#3ab0ef, #319dd9)
      }
      .el-card__body {
        height: 168px;
        line-height: 168px;
        text-align: center;
        font-size: 36px;
        color: #424958;
        background: #e7f3ff;
      }
      .billQuery_card-span {
        padding-left: 15px;
        font-size: 24px;
        vertical-align: bottom;
      }
    }
  }
</style>
